module.exports = "/_next/static/images/contact-mobile@3x-81517c21ea12c4bfc2b4b34627e38568.png";